import React from "react";
import DashboardDataAnalysis from "../graphs/DashboardDataAnalysisChart";
import DashboardAppUsageChart from "../graphs/DashboardAppUsageChart";
import DashboardGoalsChart from "../graphs/DashboardGoalsChart";

const DashboardLayout = () => {
  const [schools, setSchools] = React.useState([]);

  return (
    <div className="container-fluid d-flex flex-column h-100 align-items-center justify-content-center">
      <div className="row mt-4">
        <div className="col-12 d-flex flex-column align-items-center justify-content-center mb-2">
          <h1 className="page-title fw-bold">Benvenuto su</h1>
        </div>
        <div className="col-12 d-flex flex-column align-items-center justify-content-center mb-2">
          <img
            src="../assets/images/brand-logos/desktop-logo.png"
            alt="Logo"
            className=""
            style={{ maxWidth: "20rem", height: "auto" }}
          />
        </div>
      </div>

      {/* <div className="row">
        <div className="col-xl-3">
          <div className="card custom-card overflow-hidden">
            <div className="card-body">
              <div className="d-flex align-items-top justify-content-between">
                <div>
                  <span className="avatar bg-primary-transparent svg-primary">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      height="24px"
                      viewBox="0 0 24 24"
                      width="24px"
                      fill="#000000"
                    >
                      <path d="M0 0h24v24H0V0z" fill="none" />
                      <path
                        d="M12 16c-2.69 0-5.77 1.28-6 2h12c-.2-.71-3.3-2-6-2z"
                        opacity=".3"
                      />
                      <circle cx="12" cy="8" opacity=".3" r="2" />
                      <path d="M12 14c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4zm-6 4c.22-.72 3.31-2 6-2 2.7 0 5.8 1.29 6 2H6zm6-6c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0-6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2z" />
                    </svg>
                  </span>
                </div>
                <div className="flex-fill ms-3 d-flex align-items-start justify-content-between">
                  <div className="d-flex align-items-center justify-content-between flex-wrap">
                    <div>
                      <p className="text-muted mb-3">Studenti in challenge</p>
                      <h4 className="mt-1">75</h4>
                    </div>
                  </div>
                  <div className="d-flex align-items-center justify-content-between">
                    <div className="text-end">
                      <p className="mb-0 text-success">+40%</p>
                      <span className="text-muted op-7 fs-11">questo mese</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-3">
          <div className="card custom-card overflow-hidden">
            <div className="card-body">
              <div className="d-flex align-items-top justify-content-between">
                <div>
                  <span className="avatar bg-secondary-transparent svg-secondary">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      height="24px"
                      viewBox="0 0 24 24"
                      width="24px"
                      fill="#000000"
                    >
                      <path d="M0 0h24v24H0V0z" fill="none" />
                      <path
                        d="M13 17c-1.1 0-2-.9-2-2V9c0-1.1.9-2 2-2h6V5H5v14h14v-2h-6z"
                        opacity=".3"
                      />
                      <path d="M21 7.28V5c0-1.1-.9-2-2-2H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-2.28c.59-.35 1-.98 1-1.72V9c0-.74-.41-1.38-1-1.72zM20 9v6h-7V9h7zM5 19V5h14v2h-6c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h6v2H5z" />
                      <circle cx="16" cy="12" r="1.5" />
                    </svg>
                  </span>
                </div>
                <div className="flex-fill ms-3 d-flex align-items-start justify-content-between">
                  <div className="d-flex align-items-center justify-content-between flex-wrap">
                    <div>
                      <p className="text-muted mb-3">Punti totalizzati</p>
                      <h4 className="mt-1">8.235</h4>
                    </div>
                  </div>
                  <div className="d-flex align-items-center justify-content-between mt-1">
                    <div className="text-end">
                      <p className="mb-0 text-success">+25%</p>
                      <span className="text-muted op-7 fs-11">questo mese</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-3">
          <div className="card custom-card overflow-hidden">
            <div className="card-body">
              <div className="d-flex align-items-top justify-content-between">
                <div>
                  <span className="avatar bg-danger-transparent svg-danger">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      enableBackground="new 0 0 24 24"
                      height="24px"
                      viewBox="0 0 24 24"
                      width="24px"
                      fill="#000000"
                    >
                      <g>
                        <rect fill="none" height="24" width="24" />
                      </g>
                      <g>
                        <g>
                          <g>
                            <path d="M7.5,4C5.57,4,4,5.57,4,7.5S5.57,11,7.5,11S11,9.43,11,7.5S9.43,4,7.5,4z M7.5,9C6.67,9,6,8.33,6,7.5S6.67,6,7.5,6 S9,6.67,9,7.5S8.33,9,7.5,9z M16.5,13c-1.93,0-3.5,1.57-3.5,3.5s1.57,3.5,3.5,3.5s3.5-1.57,3.5-3.5S18.43,13,16.5,13z M16.5,18 c-0.83,0-1.5-0.67-1.5-1.5s0.67-1.5,1.5-1.5s1.5,0.67,1.5,1.5S17.33,18,16.5,18z M5.41,20L4,18.59L18.59,4L20,5.41L5.41,20z" />
                          </g>
                        </g>
                      </g>
                    </svg>
                  </span>
                </div>
                <div className="flex-fill ms-3 d-flex align-items-start justify-content-between">
                  <div className="d-flex align-items-center justify-content-between flex-wrap">
                    <div>
                      <p className="text-muted mb-3">% di partecipazione</p>
                      <h4 className="mt-1">12.08%</h4>
                    </div>
                  </div>
                  <div className="d-flex align-items-center justify-content-between mt-1">
                    <div className="text-end">
                      <p className="mb-0 text-danger">-12%</p>
                      <span className="text-muted op-7 fs-11">questo mese</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-3">
          <div className="card custom-card overflow-hidden">
            <div className="card-body">
              <div className="d-flex align-items-top justify-content-between">
                <div>
                  <span className="avatar bg-warning-transparent svg-warning">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      height="24px"
                      viewBox="0 0 24 24"
                      width="24px"
                      fill="#000000"
                    >
                      <path d="M0 0h24v24H0V0z" fill="none" />
                      <path
                        d="M15 17H9v-1H5v3h14v-3h-4zM4 14h5v-3h6v3h5V9H4z"
                        opacity=".3"
                      />
                      <path d="M20 7h-4V5l-2-2h-4L8 5v2H4c-1.1 0-2 .9-2 2v5c0 .75.4 1.38 1 1.73V19c0 1.11.89 2 2 2h14c1.11 0 2-.89 2-2v-3.28c.59-.35 1-.99 1-1.72V9c0-1.1-.9-2-2-2zM10 5h4v2h-4V5zm9 14H5v-3h4v1h6v-1h4v3zm-8-4v-2h2v2h-2zm9-1h-5v-3H9v3H4V9h16v5z" />
                    </svg>
                  </span>
                </div>
                <div className="flex-fill ms-3 d-flex align-items-start justify-content-between">
                  <div className="d-flex align-items-center justify-content-between flex-wrap">
                    <div>
                      <p className="text-muted mb-3">Download App</p>
                      <h4 className="mt-1">125</h4>
                    </div>
                  </div>
                  <div className="d-flex align-items-center justify-content-between mt-1">
                    <div className="text-end">
                      <p className="mb-0 text-success">+19%</p>
                      <span className="text-muted op-7 fs-11">questo mese</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-xxl-9 col-xl-8">
          <div className="card custom-card">
            <div className="card-header justify-content-between">
              <div className="card-title">Analisi dati</div>
              <div className="dropdown">
                <a
                  className="p-2 fs-12 text-muted"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  Visualizza tutto
                  <i className="ri-arrow-down-s-line align-middle ms-1 d-inline-block"></i>
                </a>
                <ul className="dropdown-menu" role="menu">
                  <li>
                    <a className="dropdown-item" href="javascript:void(0);">
                      Oggi
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="javascript:void(0);">
                      Questa settimana
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="javascript:void(0);">
                      Ultima settimana
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="card-body">
              <div className="content-wrapper">
                <DashboardDataAnalysis />
              </div>
            </div>
          </div>
        </div>
        <div className="col-xxl-3 col-xl-4">
          <div className="card custom-card">
            <div className="card-header justify-content-between">
              <div className="card-title">Utilizzo App</div>
              <div className="dropdown">
                <a
                  aria-label="anchor"
                  href="javascript:void(0);"
                  className="btn btn-icon btn-sm btn-light"
                  data-bs-toggle="dropdown"
                >
                  <i className="fe fe-more-vertical"></i>
                </a>
                <ul className="dropdown-menu">
                  <li>
                    <a className="dropdown-item" href="javascript:void(0);">
                      Settimana
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="javascript:void(0);">
                      Mese
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="javascript:void(0);">
                      Anno
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="card-body p-0 overflow-hidden">
              <div className="leads-source-chart d-flex align-items-center justify-content-center p-3 border-bottom border-block-end-dashed">
                <DashboardAppUsageChart />
              </div>
              <div className="row row-cols-12">
                <div className="col-6 p-0">
                  <div className="ps-4 py-3 pe-3 d-flex align-items-center flex-wrap justify-content-center gap-3">
                    <div>
                      <span className="avatar bg-primary-transparent svg-primary">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          height="24px"
                          viewBox="0 0 24 24"
                          width="24px"
                          fill="#000000"
                        >
                          <path d="M0 0h24v24H0V0z" fill="none" />
                          <path d="M7 4h9v14H7z" opacity=".3" />
                          <path d="M15.5 1h-8C6.12 1 5 2.12 5 3.5v17C5 21.88 6.12 23 7.5 23h8c1.38 0 2.5-1.12 2.5-2.5v-17C18 2.12 16.88 1 15.5 1zm-4 21c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm4.5-4H7V4h9v14z" />
                        </svg>
                      </span>
                    </div>
                    <div>
                      <span className="text-muted fs-12 mb-1 d-inline-block">
                        Mobile
                      </span>
                      <div>
                        <span className="fs-16">1,624</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-6 p-0">
                  <div className="p-3 d-flex align-items-center flex-wrap justify-content-center gap-3">
                    <div>
                      <span className="avatar bg-secondary-transparent svg-secondary">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          height="24px"
                          viewBox="0 0 24 24"
                          width="24px"
                          fill="#000000"
                        >
                          <path d="M0 0h24v24H0V0z" fill="none" />
                          <path d="M3 4h18v12H3z" opacity=".3" />
                          <path d="M21 2H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h7v2H8v2h8v-2h-2v-2h7c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H3V4h18v12z" />
                        </svg>
                      </span>
                    </div>
                    <div>
                      <span className="text-muted fs-12 mb-1 d-inline-block">
                        Desktop
                      </span>
                      <div>
                        <span className="fs-16">1,267</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-6 p-0">
                  <div className="p-3 d-flex align-items-center flex-wrap justify-content-center gap-3">
                    <div>
                      <span className="avatar bg-success-transparent svg-success">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          height="24px"
                          viewBox="0 0 24 24"
                          width="24px"
                          fill="#000000"
                        >
                          <path d="M0 0h24v24H0V0z" fill="none" />
                          <path d="M4 5h16v11H4z" opacity=".3" />
                          <path d="M20 18c1.1 0 1.99-.9 1.99-2L22 5c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2H0c0 1.1.9 2 2 2h20c1.1 0 2-.9 2-2h-4zM4 5h16v11H4V5zm8 14c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z" />
                        </svg>
                      </span>
                    </div>
                    <div>
                      <span className="text-muted fs-12 mb-1 d-inline-block">
                        Laptop
                      </span>
                      <div>
                        <span className="fs-16">1,153</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-6 p-0">
                  <div className="p-3 d-flex align-items-center flex-wrap justify-content-center gap-3">
                    <div>
                      <span className="avatar bg-danger-transparent svg-danger">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          height="24px"
                          viewBox="0 0 24 24"
                          width="24px"
                          fill="#000000"
                        >
                          <path
                            d="M0 0h24v24H0V0zm0 0h24v24H0V0z"
                            fill="none"
                          />
                          <path d="M4.75 3h14.5v16H4.75z" opacity=".3" />
                          <path d="M18 0H6C4.34 0 3 1.34 3 3v18c0 1.66 1.34 3 3 3h12c1.66 0 3-1.34 3-3V3c0-1.66-1.34-3-3-3zm-4 22h-4v-1h4v1zm5.25-3H4.75V3h14.5v16z" />
                        </svg>
                      </span>
                    </div>
                    <div>
                      <span className="text-muted fs-12 mb-1 d-inline-block">
                        Tablet
                      </span>
                      <div>
                        <span className="fs-16">679</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-xxl-4">
          <div className="card custom-card">
            <div className="card-header justify-content-between">
              <div className="card-title">Attività recenti</div>
              <div className="dropdown">
                <a
                  href="javascript:void(0);"
                  className="p-2 fs-12 text-muted"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  Guarda tutto
                  <i className="ri-arrow-down-s-line align-middle ms-1 d-inline-block"></i>
                </a>
                <ul className="dropdown-menu" role="menu">
                  <li>
                    <a className="dropdown-item" href="javascript:void(0);">
                      Oggi
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="javascript:void(0);">
                      Questa settimana
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="javascript:void(0);">
                      Ultima settimana
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="card-body">
              <div>
                <ul className="list-unstyled mb-0 crm-recent-activity">
                  <li className="crm-recent-activity-content">
                    <div className="d-flex align-items-top">
                      <div className="me-3">
                        <span className="avatar avatar-sm">
                          <img src="../assets/images/faces/1.jpg" alt="" />
                        </span>
                      </div>
                      <div className="crm-timeline-content">
                        <span>Update of calendar events &amp;</span>
                        <span>
                          <a
                            href="javascript:void(0);"
                            className="text-primary"
                          >
                            {" "}
                            Added new events in next week.
                          </a>
                        </span>
                      </div>
                      <div className="flex-fill text-end">
                        <span className="d-block text-muted fs-11 op-7">
                          4:45PM
                        </span>
                      </div>
                    </div>
                  </li>
                  <li className="crm-recent-activity-content">
                    <div className="d-flex align-items-top">
                      <div className="me-3">
                        <span className="avatar avatar-sm bg-success">SW</span>
                      </div>
                      <div className="crm-timeline-content">
                        <span>
                          New theme for{" "}
                          <span className="text-secondary">Spruko Website</span>{" "}
                          completed
                        </span>
                        <span className="d-block fs-12 text-muted">
                          Lorem ipsum, dolor sit amet.
                        </span>
                      </div>
                      <div className="flex-fill text-end">
                        <span className="d-block text-muted fs-11 op-7">
                          3 hrs
                        </span>
                      </div>
                    </div>
                  </li>
                  <li className="crm-recent-activity-content">
                    <div className="d-flex align-items-top">
                      <div className="me-3">
                        <span className="avatar avatar-sm">
                          <img src="../assets/images/faces/13.jpg" alt="" />
                        </span>
                      </div>
                      <div className="crm-timeline-content">
                        <span>
                          Created a{" "}
                          <span className="text-success">New Task</span> Oggi{" "}
                          <span className="avatar avatar-xs bg-purple-transparent avatar-rounded ms-1">
                            <i className="ri-add-fill text-purple fs-12"></i>
                          </span>
                        </span>
                      </div>
                      <div className="flex-fill text-end">
                        <span className="d-block text-muted fs-11 op-7">
                          22 hrs
                        </span>
                      </div>
                    </div>
                  </li>
                  <li className="crm-recent-activity-content">
                    <div className="d-flex align-items-top">
                      <div className="me-3">
                        <span className="avatar avatar-sm">
                          <img src="../assets/images/faces/3.jpg" alt="" />
                        </span>
                      </div>
                      <div className="crm-timeline-content">
                        <span>
                          New member{" "}
                          <span className="badge bg-pink-transparent">
                            @andreas gurrero
                          </span>{" "}
                          added Oggi to AI Summit.
                        </span>
                      </div>
                      <div className="flex-fill text-end">
                        <span className="d-block text-muted fs-11 op-7">
                          Oggi
                        </span>
                      </div>
                    </div>
                  </li>
                  <li className="crm-recent-activity-content">
                    <div className="d-flex align-items-top">
                      <div className="me-3">
                        <span className="avatar avatar-sm">
                          <img src="../assets/images/faces/9.jpg" alt="" />
                        </span>
                      </div>
                      <div className="crm-timeline-content">
                        <span>32 New people joined summit.</span>
                      </div>
                      <div className="flex-fill text-end">
                        <span className="d-block text-muted fs-11 op-7">
                          22 hrs
                        </span>
                      </div>
                    </div>
                  </li>
                  <li className="crm-recent-activity-content">
                    <div className="d-flex align-items-top">
                      <div className="me-3">
                        <span className="avatar avatar-sm bg-danger">NT</span>
                      </div>
                      <div className="crm-timeline-content">
                        <span>
                          Neon Tarly added{" "}
                          <span className="text-info">Robert Bright</span> to AI
                          summit project.
                        </span>
                      </div>
                      <div className="flex-fill text-end">
                        <span className="d-block text-muted fs-11 op-7">
                          12 hrs
                        </span>
                      </div>
                    </div>
                  </li>
                  <li className="crm-recent-activity-content">
                    <div className="d-flex align-items-top">
                      <div className="me-3">
                        <span className="avatar avatar-sm">
                          <img src="../assets/images/faces/4.jpg" alt="" />
                        </span>
                      </div>
                      <div className="crm-timeline-content">
                        <span>
                          Replied to new support request{" "}
                          <i className="ri-checkbox-circle-line text-success fs-16 align-middle"></i>
                        </span>
                      </div>
                      <div className="flex-fill text-end">
                        <span className="d-block text-muted fs-11 op-7">
                          4 hrs
                        </span>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xxl-4">
          <div className="card custom-card">
            <div className="card-header">
              <div className="card-title">Traguardi raggiunti</div>
            </div>
            <div className="card-body pt-0">
              <DashboardGoalsChart />
            </div>
          </div>
        </div>
        <div className="col-xxl-4">
          <div className="card custom-card">
            <div className="card-header justify-content-between">
              <div className="card-title">Top Player</div>
              <div className="dropdown">
                <a
                  aria-label="anchor"
                  href="javascript:void(0);"
                  className="btn btn-icon btn-sm btn-light"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <i className="fe fe-more-vertical"></i>
                </a>
                <ul className="dropdown-menu">
                  <li>
                    <a className="dropdown-item" href="javascript:void(0);">
                      Settimana
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="javascript:void(0);">
                      Mese
                    </a>
                  </li>
                  <li>
                    <a className="dropdown-item" href="javascript:void(0);">
                      Anno
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="card-body">
              <ul className="list-unstyled crm-top-deals mb-0">
                <li>
                  <div className="d-flex align-items-center flex-wrap">
                    <div className="me-2 lh-1">
                      <span className="avatar avatar-rounded">
                        <img src="../assets/images/faces/10.jpg" alt="" />
                      </span>
                    </div>
                    <div className="flex-fill">
                      <span className="fs-14 d-block mb-1">Michael Jordan</span>
                      <span className="text-muted fs-12">
                        michael.jordan@example.com
                      </span>
                    </div>
                    <div>
                      <span className="badge bg-warning-transparent">
                        Warm Leads
                      </span>
                    </div>
                  </div>
                </li>
                <li>
                  <div className="d-flex align-items-center flex-wrap">
                    <div className="me-2 lh-1">
                      <span className="avatar avatar-rounded bg-warning-transparent">
                        <img src="../assets/images/faces/6.jpg" alt="" />
                      </span>
                    </div>
                    <div className="flex-fill">
                      <span className="fs-14 d-block mb-1">Emigo Kiaren</span>
                      <span className="text-muted fs-12">
                        emigo.kiaren@gmail.com
                      </span>
                    </div>
                    <div>
                      <span className="badge bg-info-transparent">
                        Hot Leads
                      </span>
                    </div>
                  </div>
                </li>
                <li>
                  <div className="d-flex align-items-center flex-wrap">
                    <div className="me-2 lh-1">
                      <span className="avatar avatar-rounded">
                        <img src="../assets/images/faces/12.jpg" alt="" />
                      </span>
                    </div>
                    <div className="flex-fill">
                      <span className="fs-14 d-block mb-1">Randy Origoan</span>
                      <span className="text-muted fs-12">
                        randy.origoan@gmail.com
                      </span>
                    </div>
                    <div>
                      <span className="badge bg-success-transparent">
                        Cold Leads
                      </span>
                    </div>
                  </div>
                </li>
                <li>
                  <div className="d-flex align-items-center flex-wrap">
                    <div className="me-2 lh-1">
                      <span className="avatar avatar-rounded bg-success-transparent">
                        GP
                      </span>
                    </div>
                    <div className="flex-fill">
                      <span className="fs-14 d-block mb-1">
                        George Pieterson
                      </span>
                      <span className="text-muted fs-12">
                        george.pieterson@gmail.com
                      </span>
                    </div>
                    <div>
                      <span className="badge bg-danger-transparent">
                        Lost Leads
                      </span>
                    </div>
                  </div>
                </li>
                <li>
                  <div className="d-flex align-items-center flex-wrap">
                    <div className="me-2 lh-1">
                      <span className="avatar avatar-rounded bg-primary-transparent">
                        <img src="../assets/images/faces/5.jpg" alt="" />
                      </span>
                    </div>
                    <div className="flex-fill">
                      <span className="fs-14 d-block mb-1">Kiara Advain</span>
                      <span className="text-muted fs-12">
                        kiaraadvain214@gmail.com
                      </span>
                    </div>
                    <div>
                      <span className="badge bg-secondary-transparent">
                        New Leads
                      </span>
                    </div>
                  </div>
                </li>
                <li>
                  <div className="d-flex align-items-center flex-wrap">
                    <div className="me-2 lh-1">
                      <span className="avatar avatar-rounded bg-primary-transparent">
                        <img src="../assets/images/faces/14.jpg" alt="" />
                      </span>
                    </div>
                    <div className="flex-fill">
                      <span className="fs-14 d-block mb-1">Jason Momoa</span>
                      <span className="text-muted fs-12">
                        jsonmomoa2132@gmail.com
                      </span>
                    </div>
                    <div>
                      <span className="badge bg-success-transparent">
                        Cold Leads
                      </span>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-xl-12">
          <div className="card custom-card">
            <div className="card-header justify-content-between">
              <div className="card-title">Top Schools</div>
              <div className="d-flex flex-wrap gap-2">
                <div>
                  <input
                    className="form-control form-control-sm"
                    type="text"
                    placeholder="Search Here"
                    aria-label=".form-control-sm example"
                  />
                </div>
                <div className="dropdown">
                  <a
                    href="javascript:void(0);"
                    className="btn btn-primary btn-sm btn-wave waves-effect waves-light"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    Ordina
                    <i className="ri-arrow-down-s-line align-middle ms-1 d-inline-block"></i>
                  </a>
                  <ul className="dropdown-menu" role="menu">
                    <li>
                      <a className="dropdown-item" href="javascript:void(0);">
                        New
                      </a>
                    </li>
                    <li>
                      <a className="dropdown-item" href="javascript:void(0);">
                        Popolari
                      </a>
                    </li>
                    <li>
                      <a className="dropdown-item" href="javascript:void(0);">
                        Rilevanti
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="card-body p-0">
              <div className="table-responsive">
                <table className="table text-nowrap table-hover">
                  <thead>
                    <tr>
                      <th scope="col">Isituto</th>
                      <th scope="col">Scuola</th>
                      <th scope="col">Dirigente</th>
                      <th scope="col">Stato</th>
                      <th scope="col">Recapito</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {schools.map((school, index) => (
                      <tr key={index}>
                        <td>{school.type}</td>
                        <td>{school.name}</td>
                        <td>{school.dirigente}</td>
                        <td>
                          <span className="badge bg-info-transparent">
                            Attiva
                          </span>
                        </td>
                        <td>{school.phone}</td>
                        <td>
                          <div className="hstack gap-2 fs-15">
                            <a
                              aria-label="anchor"
                              href="javascript:void(0);"
                              className="btn btn-icon btn-wave waves-effect waves-light btn-sm btn-success-light rounded-circle"
                            >
                              <i className="ri-phone-line"></i>
                            </a>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="card-footer border-top-0">
              <div className="d-flex align-items-center">
                <div>
                  Showing 5 Entries <i className="bi bi-arrow-right ms-2"></i>
                </div>
                <div className="ms-auto">
                  <nav
                    aria-label="Page navigation"
                    className="pagination-style-4"
                  >
                    <ul className="pagination mb-0">
                      <li className="page-item disabled">
                        <a className="page-link" href="javascript:void(0);">
                          Prev
                        </a>
                      </li>
                      <li className="page-item active">
                        <a className="page-link" href="javascript:void(0);">
                          1
                        </a>
                      </li>
                      <li className="page-item">
                        <a className="page-link" href="javascript:void(0);">
                          2
                        </a>
                      </li>
                      <li className="page-item">
                        <a
                          className="page-link text-primary"
                          href="javascript:void(0);"
                        >
                          next
                        </a>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}
    </div>
  );
};

export default DashboardLayout;
